(function () {
  var roots = document.querySelectorAll('[data-td-hero]');
  roots.forEach(function (root) {
    var slides = root.querySelectorAll('[data-td-slide-index]');
    var dots = root.querySelectorAll('[data-td-hero-dot]');
    var prevBtn = root.querySelector('[data-td-hero-prev]');
    var nextBtn = root.querySelector('[data-td-hero-next]');
    if (slides.length < 2) return;

    var current = 0;
    var auto = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-autoplay-speed') || '5', 10) * 1000;
    var timer = null;

    function show(target) {
      var total = slides.length;
      var next = target;
      while (next < 0) next = next + total;
      next = next - (Math.floor(next / total) * total);
      current = next;
      for (var i = 0; i < slides.length; i++) {
        if (i === current) {
          slides[i].classList.add('is-active');
        } else {
          slides[i].classList.remove('is-active');
        }
      }
      for (var j = 0; j < dots.length; j++) {
        if (j === current) {
          dots[j].classList.add('is-active');
          dots[j].setAttribute('aria-selected', 'true');
        } else {
          dots[j].classList.remove('is-active');
          dots[j].setAttribute('aria-selected', 'false');
        }
      }
    }

    function start() {
      if (auto && !timer) {
        timer = setInterval(function () { show(current + 1); }, speed);
      }
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { show(current - 1); stop(); start(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { show(current + 1); stop(); start(); });
    }
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { show(idx); stop(); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    start();
  });
})();
